export const ALLOWED_PAYMENT_TYPES = [
    'PIX',
    'CREDIT_CARD',
] as const
